import React from "react";

import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

import app from "../firebase";

import storageKey from "../storageKey";
import { Dev } from "../util/consoleUtil";
import { CustomCache } from "../util/customCache";
import firebaseError from "../util/firebaseError";

import { MenuItem, ReportType } from "../../types/database";

const db = getFirestore(app);
const storage = getStorage(app);

export const MenuService = {
  One: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<ReportType | null>(null);

    const runRequest = async (itemId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);
          const mainRef = doc(db, "menu", itemId);
          const mainSnap = await getDoc(mainRef);

          const itemObj = { id: itemId, ...mainSnap.data() } as ReportType;
          setLoading(false);

          if (!mainSnap.exists()) return Rej(new Error("Item não existe."));

          setItem(itemObj);

          Ok(itemObj);
        } catch (error) {
          console.log(...new Dev("Request Error [one]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  ListOne: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<object | null>(null);

    const runRequest = async (periodTimestamp: number) => {
      return new Promise(async (Ok, Rej) => {
        try {
          const cacheData = CustomCache.get(storageKey.CUSTOM_CACHE.RU_MENU, 2);

          if (cacheData) {
            setItem(cacheData);
            return Ok(cacheData);
          }

          setLoading(true);

          const mainRef = collection(db, "menu");
          const queryRef = query(
            mainRef,
            where("updatedAtTimestamp", ">=", periodTimestamp),
            orderBy("updatedAtTimestamp", "desc"),
            limit(1)
          );
          const mainSnap = await getDocs(queryRef);
          const listData = [] as MenuItem[];

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() } as MenuItem);
          });

          const oneItem = listData[0] || null;

          setItem(oneItem);
          if (oneItem?.dinner?.protein) CustomCache.save(storageKey.CUSTOM_CACHE.RU_MENU, oneItem);

          setLoading(false);
          Ok(oneItem);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  List: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [item, setItem] = React.useState<any[] | null>(null);

    const runRequest = async (periodTimestamp: number) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "menu");
          const queryRef = query(mainRef, where("updatedAtTimestamp", ">=", periodTimestamp));
          const mainSnap = await getDocs(queryRef);
          const listData = [] as any;

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() });
          });

          setItem(listData);

          setLoading(false);
          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { item, isLoading, runRequest };
  },

  Create: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (item: ReportType) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "menu");
          const mainSnap = await addDoc(mainRef, item);

          setLoading(false);
          Ok(true);
        } catch (error) {
          console.log(...new Dev("Request Error [create]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao criar dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },

  Delete: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (itemId: string) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = doc(db, "menu", itemId);
          const mainSnap = await deleteDoc(mainRef);

          setLoading(false);
          Ok(true);
        } catch (error) {
          console.log(...new Dev("Request Error [delete]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao remover dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },

  Update: () => {
    const [isLoading, setLoading] = React.useState(false);

    const runRequest = async (itemId: string, payload: any) => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = doc(db, "menu", itemId);
          const mainSnap = await updateDoc(mainRef, payload);

          setLoading(false);
          Ok(true);
        } catch (error) {
          console.log(...new Dev("Request Error [update]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao atualizar dados. " + firebaseError(error)));
        }
      });
    };

    return { isLoading, runRequest };
  },
};
